import React, { FC } from 'react';
import { Badge } from '@chakra-ui/react';

interface LBadgeProps {
  title: string | number;
  solid?: boolean;
}

const LBadge: FC<LBadgeProps> = ({
  title,
  solid = false,
}) => (
  <Badge
    colorScheme='brand'
    variant={solid ? 'solid' : 'outline'}
    borderRadius='50%'
    minW={5}
    width={5}
    height={5}
    justifyContent='center'
    alignItems='center'
    display='flex'
  >
    {title}
  </Badge>
);

export default LBadge;
